import { render, staticRenderFns } from "./MiniLoader.vue?vue&type=template&id=1de0a04a"
import script from "./MiniLoader.vue?vue&type=script&lang=js"
export * from "./MiniLoader.vue?vue&type=script&lang=js"
import style0 from "./MiniLoader.vue?vue&type=style&index=0&id=1de0a04a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports